import {
    FETCH_CAMPAIGN_REPORT,
    FETCH_CAMPAIGN_USAGES_REPORT,
    FETCH_MEMBER_PURCHASE_HISTORY
} from '../../actions/types';

const INITIAL_STATE = {
    campaignReport: [],
    campaignUsagesReport: [],
    memberHistoryReport: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {        
        case FETCH_CAMPAIGN_REPORT:
            return { ...state, campaignReport: action.payload };
        case FETCH_CAMPAIGN_USAGES_REPORT:
            return { ...state, campaignUsagesReport: action.payload };
        case FETCH_MEMBER_PURCHASE_HISTORY:
            return { ...state, memberHistoryReport: action.payload };
        default:
            return state;
    }
};
